import {TagColorName} from '@wandb/weave/components/Tag';
import React, {createContext, useContext} from 'react';

type IconColorContextProviderProps = {
  children: React.ReactNode;
  iconColor: TagColorName;
};

const IconColorContext = createContext<TagColorName | undefined>(undefined);

export const IconColorContextProvider = ({
  children,
  iconColor,
}: IconColorContextProviderProps) => {
  return (
    <IconColorContext.Provider value={iconColor}>
      {children}
    </IconColorContext.Provider>
  );
};

export const useIconColorContext = (): TagColorName => {
  const value = useContext(IconColorContext);
  if (value == null) {
    throw new Error(
      'useIconColorContext must be used within a IconColorContextProvider'
    );
  }
  return value;
};
